import styled from 'styled-components';
import { colors } from '@styles';
import { DatePicker, Select } from 'antd';
import { flexMixin, respondTo, textMixin } from '@styles/mixins';

const { RangePicker } = DatePicker;

export const Wrapper = styled.div`
    min-width: 100%;
    height: 80%;
    background-color: ${colors.bgWhite};
    padding: 16px 0 16px 0;
`;

export const Header = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')};
    flex-wrap: wrap;
    margin-bottom: 20px;
    ${respondTo.mobile`
      gap:10px
   `}
`;

export const StyledRangePicker = styled(RangePicker)`
    width: 250px;
    color: ${colors.cleanWhite};
`;

export const StyledSelect = styled(Select)`
    box-sizing: border-box;
    ${flexMixin('row', 'center', 'center')}
    gap: 10px;
    width: 175px;
    height: 38px;
    ${respondTo.mobile`
      margin-bottom: 20px;
   `}
`;
export const ChartsWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    max-height: 100vh;
    margin-bottom: 20px;
    padding: 30px;
    background-color: ${colors.cleanWhite};
    border-radius: 5px;
`;
export const StyledCalendarWrapper = styled.div`
    display: flex;
    gap: 10px;
    color: ${colors.bgWhite};

    & svg {
        width: 20px;
        height: 20px;
    }
    .ant-picker {
        background-color: ${colors.primaryBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        text-align: center;
        color: ${colors.bgWhite};
    }

    .ant-picker .ant-picker-input,
    .ant-picker .ant-picker-range,
    .ant-picker .ant-picker-input-active .ant-picker-input-placeholder {
        display: flex;
        flex-direction: row-reverse;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        color: ${colors.bgWhite};
    }

    .ant-picker .ant-picker-input .ant-picker-input-active {
        color: ${colors.bgWhite} !important;
    }

    .ant-picker .ant-picker-input .ant-picker-input-placeholder {
        color: ${colors.bgWhite} !important;
    }

    .ant-picker .ant-picker-input span.ant-picker-suffix,
    .ant-picker.ant-picker-range span.ant-picker-suffix {
        order: -1;
        margin-left: 0;
        margin-right: 10px;
        color: ${colors.bgWhite};
    }

    .ant-picker.ant-picker-range.ant-picker-range-separator {
        color: ${colors.bgWhite}!important;
    }

    .ant-picker-range-separator > span {
        color: ${colors.bgWhite} !important;
    }

    .ant-picker-clear {
        color: ${colors.bgWhite} !important;
    }

    .ant-picker .ant-picker-clear {
        position: absolute;
        right: 217px;
    }
`;
export const StyledHeadTitle = styled.label`
    ${textMixin({
        fontSize: '25px',
        fontWeight: 600,
    })};
    line-height: 28px;
    text-align: left;
    color: ${colors.grey};
`;
